import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useSubmotive1Form } from './hook';
import { Submotive1Data } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    SUBMOTIVE1,
    SUBMOTIVE1_DETAIL,
    SUBMOTIVE1_EDIT,
    SUBMOTIVE1_NEW,
} from '../../../../../routes/paths';
import { Submotive1ParamsHistorical } from '../historical';

export const Submotive1Form = () => {
    const {
        submotive1,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive1Data,
        submotive1Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive1Form();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    submotive1 && submotive1.id
                        ? 'Editar submotivo 1'
                        : 'Crear submotivo 1'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive1?.id || ''}
                        buttonCreate={{
                            show: Boolean(submotive1?.id),
                            route: SUBMOTIVE1_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE1,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: SUBMOTIVE1_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE1_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive1?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <Submotive1ParamsHistorical
                        historical={submotive1Historical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <Submotive1Data
                data={submotive1}
                onChangeFormik={(formik) => setFormikSubmotive1Data(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
